import { useMutation } from "@tanstack/react-query"
import {createAxiosWithAuth} from './middleware'

export const useDeclineFuelRequest = () =>{   
  const axios = createAxiosWithAuth();

   return useMutation({
      mutationFn: async (query) => {
        return await axios.post('/fuelrequest/cancel', query)
      },
    })
}